module.exports = __webpack_public_path__ + "img/endofshow.8df3ca8d.jpg";